<template>
  <v-dialog v-model="dialog" scrollable max-width="800" @click:outside="closeDialog" @keydown.esc="closeDialog">
    <v-card class="py-3">
      <v-card-title class="subheadline px-4">
        <span class="ml-2">Visualización</span>
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row class="fill-height">
          <v-col cols="12" class="text-center">
            <img :src="url" style="max-width: 100% !important" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ImageViewer",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>
